import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolder = () => {
  return (
    <g>
      <path d="m15.1772 3.63h-7.0947l-1.3476-2.3453a.75.75 0 0 0 -.65-.377h-5.2621a.75.75 0 0 0 -.75.75v12.6846a.75.75 0 0 0 .75.75h14.3544a.75.75 0 0 0 .75-.75v-9.9623a.75.75 0 0 0 -.75-.75zm-9.5272-1.2223.7024 1.2223h-4.78v-1.2223zm8.7773 11.1846h-12.8545v-8.4623h12.8545v8.4619z" />
    </g>
  );
};

export default withIcon(IconFolder);
